<form (ngSubmit)="onSubmit()" [formGroup]="form">

  <evland-form-container [config]="formConfig" class="form-container">

    <div class="form-content row mb-3" form-content>

      <div class="col-12 col-md-5">

        <div class="row">

          <div class="col-12 col-xl-6">

            <evland-form-field label="Ваше ім'я" i18n-label>
              <input evlandInput formControlName="name" class="form-control" id="name" />
            </evland-form-field>

          </div>

          <div class="col-12 col-xl-6">

            <evland-form-field label="Номер телефону" i18n-label>
              <input [imask]="{ mask: '+{38\\0} (00) 000-00-00' }" evlandInput formControlName="contactNumber"
                     class="form-control" placeholder="+380 (XX) XXX-XX-XX" />
            </evland-form-field>

          </div>

        </div>

      </div>

    </div>

    <div class="form-footer row" form-footer>

      <div class="col-12 col-md-5">

        <evland-submit-button [isLoading]="isSubmitting()" class="d-block flex-fill" i18n>Чекаю дзвінка
        </evland-submit-button>

      </div>

    </div>

    <img [useSrcset]="true" class="splash-image d-none d-md-block"
         lazyLoad="/assets/images/questions-cta-form/splash.webp 1x, /assets/images/questions-cta-form/splash@2x.webp 2x, /assets/images/questions-cta-form/splash@3x.webp 3x"
         alt="Два смартфона" i18n-alt />

  </evland-form-container>

</form>
